import isNil from 'lodash/isNil'

/**
 * Adds or replaces the given unavailability into the given unavailabilities:
 * if no index is specified, the unavailability will be added at the end of the
 * list, otherwise it will replace the unavailability at the given index.
 * @param {Object} unavailability The unavailability to add
 * @param {Array} unavailabilities The unavailabilities list
 * @param {Number} [index] The index of the unavailability to replace or nothing
 * @return {Array} A new array with the added unavailability
 */
export const putUnavailability = (unavailability, unavailabilities, index) =>
  // if specified index is nil
  isNil(index)
    ? // add the new unavailability
      [...unavailabilities, unavailability]
    : // otherwise replace the unavailability at the given index by the new one
      [...unavailabilities.slice(0, index), unavailability, ...unavailabilities.slice(index + 1)]

/**
 * Removes an unavailability from the given unavailabilities according to its index.
 * @param {Array} unavailabilities The unavailabilities list
 * @param {Number} index The index of the unavailability to remove
 * @return {Object|Array}
 */
export const removeUnavailability = (unavailabilities, index) => [
  ...unavailabilities.slice(0, index),
  ...unavailabilities.slice(index + 1),
]
